export const DEFAULT_MODAL_HEADER_HEIGHT = 60;
